import { settingsConstants as sc } from './constant'

const initialState = {
  credValue: null,
  formActive: false,
  notificationsformActive: false,
  verificationFormActive: false,
  organizationDocsActive: false,
  integrationActive: false,
  groupFormActive: false,
  emailValidationSuccess: null,
  emailValidationFailure: null,
  emailActivationSuccess: null,
  emailActivationFailure: null,
  passwordResetSuccess: null,
  passwordResetFailure: null,
  loading: false,
  toggleAllSetting: null,
  toggleAllGroupSetting: null,
  passwordResetSuccess: false,
  reloadDefaultNotifications: false,
  reloadGroupNotifications: false,
  codeError: false,
  codeSuccess: false,
  userDetails: {
    email: '',
    phone_number: '',
    country_code: '',
    success: false,
    loading: false
  },
  groupList: [],
  groupDetails: {
    id: null,
    name: null,
    role: null,
    picture: null
  },
  defaultNotificationList: [],
  notificationList: [],
  updatedEmail: '',
  language: {
    updated: false,
    loading: false,
    error: null,
    value: ''
  },
  firstNameObj: {
    name: 'firstName',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  },
  lastNameObj: {
    name: 'lastName',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  },
  nameUpdated: false,
  newEmailObj: {
    name: 'newEmail',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  },
  newEmailConfirmationObj: {
    name: 'newEmailConfirmation',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  },
  codeActivationObj: {
    name: 'codeActivation',
    value: '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  },
  deactivateAccData: {
    orgId: 0,
    loading: false,
    error: '',
    data: false,
    emailSentMessage: ''
  }
}

export function settings(state = initialState, action) {
  switch (action.type) {
    case sc.CRED_VALUE:
      return {
        ...state,
        credValue: action.value
      }
    case sc.SET_NOTIFICATION_FORM_STATUS:
      return {
        ...state,
        notificationsformActive: action.value
      }
    case sc.SET_CODE_ERROR:
      return {
        ...state,
        codeError: action.value
      }
    case sc.SET_SUCCESS:
      return {
        ...state,
        codeSuccess: action.value
      }
    case sc.UPDATE_FORM_TOGGLE_STATUS:
      return {
        ...state,
        formActive: action.value
      }
    case sc.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.response
      }
    case sc.SET_VERFICATION_FORM_STATUS:
      return {
        ...state,
        verificationFormActive: action.value
      }
    case sc.SET_ORG_DOCS_STATUS:
      return {
        ...state,
        organizationDocsActive: action.value
      }
    case sc.SET_INTEGRATION_STATUS:
      return {
        ...state,
        integrationActive: action.value
      }
    case sc.SET_UPDATED_EMAIL:
      return {
        ...state,
        updatedEmail: action.value
      }
    case sc.SET_COUNTRY_CODE:
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          country_code: action.value
        }
      }
    case sc.SET_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        resetSuccess: action.value
      }
    case sc.PUT_EMAIL_SUCCESS:
      return {
        ...state,
        emailUpdateSuccess: action.response,
        userDetails: {
          ...state.userDetails,
          email: action.response
        }
      }
    case sc.PUT_EMAIL_FAILURE:
      return {
        ...state,
        emailUpdateFailure: action.error
      }
    case sc.PUT_PASSWORD_SUCCESS:
      return {
        ...state,
        passwordUpdateSuccess: action.response
      }
    case sc.PUT_PASSWORD_FAILURE:
      return {
        ...state,
        passwordUpdateFailure: action.error
      }
    case sc.PUT_NUMBER_SUCCESS:
      return {
        ...state,
        numberUpdateSuccess: action.response,
        userDetails: {
          ...state.userDetails,
          phone_number: action.response.phone_number
        }
      }
    case sc.PUT_NUMBER_FAILURE:
      return {
        ...state,
        numberUpdateFailure: action.error
      }

    case sc.PUT_USER_INFO_REQUEST: {
      return {
        ...state,
        userDetails: {
          success: false,
          loading: true
        }
      }
    }
    case sc.PUT_USER_INFO_SUCCESS: {
      const { updated } = action.response
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          loading: false,
          gender: updated?.key === 'gender' ? updated.value : state.userDetails.gender,
          birthday: updated?.key === 'birthday' ? updated.value : state.userDetails.birthday,
          success: true
        }
      }
    }
    case sc.PUT_USER_INFO_FAILURE: {
      return {
        ...state,
        userDetails: {
          ...state.userDetails,
          success: false,
          loading: false,
          error: action.error
        }
      }
    }
    case sc.EMAIL_ACTIVATION_CODE_SUCCESS:
      return {
        ...state,
        emailActivationSuccess: action.response
      }
    case sc.EMAIL_ACTIVATION_CODE_FAILURE:
      return {
        ...state,
        emailActivationFailure: action.error
      }
    case sc.EMAIL_CODE_VALIDATION_SUCCESS:
      return {
        ...state,
        emailValidationSuccess: action.response
      }
    case sc.EMAIL_CODE_VALIDATION_FAILURE:
      return {
        ...state,
        emailValidationFailure: action.error
      }
    case sc.SET_PASSWORD_RESET_KEY_SUCCESS:
      return {
        ...state,
        passwordResetSuccess: action.response
      }
    case sc.SET_PASSWORD_RESET_KEY_FAILURE:
      return {
        ...state,
        passwordResetFailure: action.error
      }
    case sc.GET_GROUP_LIST_SUCCESS:
      return {
        ...state,
        groupList: action.response
      }
    case sc.GET_DEFAULT_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        defaultNotificationList: action.response
      }
    case sc.GET_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        notificationList: action.response
      }
    case sc.SET_GROUP_FORM_STATUS:
      return {
        ...state,
        groupFormActive: action.value
      }
    case sc.SET_GROUP_DETAILS:
      return {
        ...state,
        groupDetails: {
          ...state.groupDetails,
          id: action.id,
          name: action.name,
          role: action.role,
          picture: action.picture
        }
      }
    case sc.UPDATE_NOTIFICATION_SETTINGS_SUCCESS:
      return {
        ...state,
        notificationSettingUpdated: action.response
      }
    case sc.ENABLE_DISABLE_ALL_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case sc.ENABLE_DISABLE_ALL_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleAllSetting: action.response,
        reloadDefaultNotifications: !state.reloadDefaultNotifications
      }
    case sc.ENABLE_DISABLE_ALL_GROUP_SETTINGS_REQUEST:
      return {
        ...state,
        loading: true
      }
    case sc.ENABLE_DISABLE_ALL_GROUP_SETTINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        toggleAllGroupSetting: action.response,
        reloadGroupNotifications: !state.reloadGroupNotifications
      }
    case sc.UPDATE_LANGUAGE_REQUEST:
      return {
        ...state,
        language: {
          ...state.language,
          loading: true
        }
      }
    case sc.UPDATE_LANGUAGE_SUCCESS:
      return {
        ...state,
        language: {
          ...state.language,
          updated: true,
          loading: false,
          value: action.response && action.response.updated && action.response.updated.value,
          error: null
        }
      }
    case sc.UPDATE_LANGUAGE_FAILURE:
      return {
        ...state,
        language: {
          ...state.language,
          updated: false,
          loading: false,
          error: action.error
        }
      }
    case sc.DEACTIVATE_ACCOUNT_REQUEST:
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: true
        }
      }
    case sc.DEACTIVATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: false,
          data: action.response
        }
      }
    case sc.DEACTIVATE_ACCOUNT_FAILURE:
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: false,
          error: action.error
        }
      }
    case sc.CLEAR_DEACTIVATE_DATA: {
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: false,
          error: '',
          data: null,
          orgId: 0,
          emailSentMessage: ''
        }
      }
    }
    case sc.REQUEST_TO_DELETE_ACCOUNT_REQUEST: {
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: true,
          orgId: action.orgId,
          emailSentMessage: ''
        }
      }
    }
    case sc.REQUEST_TO_DELETE_ACCOUNT_SUCCESS: {
      localStorage.setItem('request_to_delete', action.orgId)
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: false,
          orgId: action.orgId,
          emailSentMessage: action.response
        }
      }
    }
    case sc.REQUEST_TO_DELETE_ACCOUNT_FAILURE:
      return {
        ...state,
        deactivateAccData: {
          ...state.deactivateAccData,
          loading: false,
          error: action.error,
          orgId: 0,
          emailSentMessage: ''
        }
      }
    case sc.PUT_NAMES_REQUEST: {
      return {
        ...state,
        nameUpdated: false
      }
    }
    case sc.PUT_NAMES_SUCCESS: {
      return {
        ...state,
        nameUpdated: true,
        userDetails: {
          ...state.userDetails,
          firstname: action.payload.firstname,
          lastname: action.payload.lastname
        }
      }
    }
    case sc.PUT_NAMES_FAILURE: {
      return {
        ...state,
        nameUpdated: false
      }
    }
    case sc.INITIAL_STATE:
      return {
        ...state,
        passwordUpdateSuccess: null,
        passwordUpdateFailure: null,
        numberUpdateSuccess: null,
        numberUpdateFailure: null,
        emailValidationSuccess: null,
        emailValidationFailure: null,
        emailActivationSuccess: null,
        emailActivationFailure: null,
        passwordResetSuccess: null,
        passwordResetFailure: null
      }
    default:
      return state
  }
}
